import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import AppBar from 'material-ui/AppBar'
import IconButton from 'material-ui/IconButton'
import FlatButton from 'material-ui/FlatButton'
import Popover from 'material-ui/Popover'
import Menu from 'material-ui/Menu'
import IconMenu from 'material-ui/IconMenu'
import MenuItem from 'material-ui/MenuItem'
import spacing from 'material-ui/styles/spacing'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import {darkWhite, lightWhite, grey900} from 'material-ui/styles/colors'
import withWidth, {MEDIUM, LARGE} from 'material-ui/utils/withWidth'
import AppNavDrawer from '../components/AppNavDrawer'
import FullWidthSection from '../components/FullWidthSection'
import UserAvatar from '../components/UserAvatar'
import NotifySnackbar from '../components/NotifySnackbar'

import {init,login,logout} from '../actions'
import locale from '../locale'

class Master extends Component {
  static propTypes = {
    children: PropTypes.node,
    location: PropTypes.object,
    width: PropTypes.number.isRequired,
  }

  static contextTypes = {
    router: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired,
  }

  static childContextTypes = {
    muiTheme: PropTypes.object,
  }

  state = {
    navDrawerOpen: false,
  }

  getChildContext() {
    return {
      muiTheme: this.state.muiTheme,
    }
  }

  componentDidMount() {
    this.props.dispatch(init())
  }

  componentWillMount() {
    let {me,lang} = this.props
    locale.set(lang)
    //workaround should be removed soon
    if(me.uid && !me.fbid) {
      this.props.dispatch(logout())
    }
    this.setState({
      muiTheme: getMuiTheme(),
    })
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme
    this.setState({
      muiTheme: newMuiTheme,
    })
  }

  getStyles() {
    const styles = {
      appBar: {
        position: 'fixed',
        // Needed to overlap the examples
        zIndex: this.state.muiTheme.zIndex.appBar + 1,
        top: 0,
      },
      root: {
        paddingTop: spacing.desktopKeylineIncrement,
        minHeight: 400,
      },
      content: {
        margin: window.innerWidth>768 ? spacing.desktopGutter:0,
      },
      contentWhenMedium: {
        margin: `${spacing.desktopGutter * 2}px ${spacing.desktopGutter * 3}px`,
      },
      footer: {
        backgroundColor: grey900,
        textAlign: 'center',
      },
      a: {
        color: darkWhite,
      },
      p: {
        margin: '0 auto',
        padding: 0,
        color: lightWhite,
        // maxWidth: 600,
      },
      browserstack: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        margin: '25px 15px 0',
        padding: 0,
        color: lightWhite,
        lineHeight: '25px',
        fontSize: 12,
      },
      browserstackLogo: {
        margin: '0 3px',
      },
      iconButton: {
        color: darkWhite,
      },
      avatar:{
        width:64,
        height:64,
        marginTop: -8
      }
    }

    if (this.props.width === MEDIUM || this.props.width === LARGE) {
      styles.content = Object.assign(styles.content, styles.contentWhenMedium)
    }

    return styles
  }

  handleTouchTapLeftIconButton = () => {
    this.setState({
      navDrawerOpen: !this.state.navDrawerOpen,
    })
  }
  handleTouchTapRightIconButton = () => {
    console.log('handleTouchTapRightIconButton')
  }


  handleChangeRequestNavDrawer = (open) => {
    this.setState({
      navDrawerOpen: open,
    })
  }

  handleChangeList = (event, value) => {
    this.context.router.push(value)
    this.setState({
      navDrawerOpen: false,
    })
  }

  handleChangeMuiTheme = (muiTheme) => {
    console.log('handleChangeMuiTheme',muiTheme)
    this.setState({
      muiTheme: muiTheme,
    })
  }

  handleLogin = () => {
    this.props.dispatch(login())
  }

  handleLogout = () =>{
    this.handleRequestClose()
    this.props.dispatch(logout())
  }

  handleTouchTap = (event) => {
    event.preventDefault();
    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    })
  }

  handleRequestClose = () => {
    this.setState({
      open: false,
    })
  }
  userButton(){
    const {me} = this.props
    let style = this.getStyles().avatar
    return (
          <IconMenu
            iconButtonElement={<IconButton style={style}><UserAvatar uid={me.fbid}/></IconButton>}
            anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
            targetOrigin={{horizontal: 'right', vertical: 'top'}}
          >
            <MenuItem primaryText={locale.R.logout} onTouchTap={this.handleLogout}/>
          </IconMenu>
      )
  }

  render() {
    const {me,title,location,children} = this.props

    let {
      navDrawerOpen,
    } = this.state

    const {
      prepareStyles,
    } = this.state.muiTheme

    const router = this.context.router
    const styles = this.getStyles()
    let docked = false
    let showMenuIconButton = true

    if (this.props.width === LARGE && !!title) {
      docked = true
      navDrawerOpen = true
      showMenuIconButton = false

      styles.navDrawer = {
        zIndex: styles.appBar.zIndex - 1,
      }
      styles.root.paddingLeft = 256
      styles.footer.paddingLeft = 256
    }

    let RightIcon = me.uid ? this.userButton()
                          : <FlatButton label={locale.R.login} onTouchTap={this.handleLogin}/>

    return (
      <div>
        <AppBar
          onLeftIconButtonTouchTap={this.handleTouchTapLeftIconButton}
          onRightIconButtonTouchTap={this.handleTouchTapRightIconButton}
          iconElementRight={RightIcon}
          title={title}
          zDepth={0}
          style={styles.appBar}
          showMenuIconButton={showMenuIconButton}
        />
        {!!title ?
          <div style={prepareStyles(styles.root)}>
            <div style={prepareStyles(styles.content)}>
              {children}
            </div>
          </div> :
          children
        }
        <AppNavDrawer
          me={me}
          style={styles.navDrawer}
          location={location}
          docked={docked}
          onRequestChangeNavDrawer={this.handleChangeRequestNavDrawer}
          onChangeList={this.handleChangeList}
          open={navDrawerOpen}
        />
        <FullWidthSection style={styles.footer}>
          <div style={prepareStyles(styles.p)}>
            {locale.R.waiverText.map((text,index)=>(<div key={index}>{text}</div>))}

            Powered by <a href="https://www.climbio.org">Climbio</a>
          </div>
        </FullWidthSection>
        <NotifySnackbar/>
      </div>
    )
  }
}

export default withWidth()(Master)

function mapStateToProps(state,props) {
  let { me,config:{title,lang} } = state
  return {
    me,
    title,
    lang
  }
}

export default connect(mapStateToProps)(withWidth()(Master))


/** WEBPACK FOOTER **
 ** ./src/app/containers/Master.js
 **/